import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  // Operation
  operation: 'executeQuery',

  // Execute Query
  query: '',
  parameters: {},

  // Table operations
  table: '',
  sourceArray: '',

  // Update operation
  matchColumn: 'id',

  // Delete operation
  deleteColumn: '',
  deleteCondition: 'equals',
  deleteValue: '',

  // Drop table
  ifExists: true,

  // Create table
  dropIfExists: false,
  insertData: true,

  // Settings
  queryTimeout: 120,
};

export default defaults;
